import {removeSpecialCharacters} from "../../../../utils/string-helpers";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";

export class GameThemeDefinition {
    constructor(public readonly id: number,
        private readonly _translationKey: string,
        private readonly services: IServiceFactoryExtended) {
        this.name = this.services.translation.translate(_translationKey);
    }

    public readonly name: string;

    isMatch(regEx: RegExp): boolean {
        return Boolean(removeSpecialCharacters(this.name).match(regEx) || removeSpecialCharacters(this._translationKey).match(regEx));
    }
}